import { Component, OnInit, Input, OnDestroy } from '@angular/core';
import { ChatService } from '../chat.service';
import { chatboxManager } from '../aside-chat/aside-chat-boxes'
import { ChatMensaje } from 'app/core/model/classes/chat';
import { SignalRService } from '../signalRService.service';
import { ChatMessage, ConnectionStatus } from 'app/core/model/classes/chatMessage';
import { CurrentUser } from 'app/core/model/trjireh-model';

@Component({
  // tslint:disable-next-line:component-selector
  selector: 'aside-chat-user',
  templateUrl: './aside-chat-user.component.html',
})
export class AsideChatUserComponent implements OnInit {

  private static idCounter = 0;
  canSendMessage = false;
  lastmsg = '';

  @Input() user: any = {};

  state: {
    chatId: string
  };

  constructor(public chatService: ChatService,
    private signalrService: SignalRService) {
    this.subscribeToEvents();
    this.state = {
      chatId: 'chatbox-user-' + AsideChatUserComponent.idCounter++
    }
  }

  subscribeToEvents() {
    this.signalrService.connectionEstablished.subscribe((connected: boolean) => {
      this.canSendMessage = connected;
    });

    this.signalrService.connectionStopped.subscribe((connected: boolean) => {
      // const currentUser = JSON.parse(localStorage.getItem('currentUser'));
      const id = 'chatbox-user-' + this.user.idUsuario;
      try { chatboxManager.delBox(id); } catch (e) {};
    });

    this.signalrService.connectionStatus.subscribe((connection: ConnectionStatus) => {
      if (this.user.usuario == connection.usuario) {
        if (connection.status == 'I') {
          this.user.status = 'online';
        } else {
          this.user.status = 'incognito';
        }
      }
    });

    this.signalrService.messageReceived.subscribe((message: ChatMessage) => {
      const currentUser = JSON.parse(localStorage.getItem('currentUser'));

      if (currentUser != null && currentUser != undefined) {
        if (this.user.usuario == message.fromUsuario &&
            currentUser.claveUsuario == message.toUsuario &&
            message.tipo == 'M') {
          // Mensaje rtecibido
          if (this.lastmsg != message.id) {
            this.lastmsg = message.id;
            this.user.status = 'online';
            this.openChat();
            const id = 'chatbox-user-' + this.user.idUsuario;
            chatboxManager.received(id, { first_name: this.user.nombre, lastid: message.id }, message.mensaje);
          }
        } else if (message.toUsuario == '*' && currentUser.claveUsuario != message.fromUsuario && this.user.usuario == '*') {
          this.lastmsg = message.id;
          this.user.status = 'online';
          this.openChat();
          const id = 'chatbox-user-' + this.user.idUsuario;
          chatboxManager.received(id, { first_name: message.nombre, lastid: message.id }, message.mensaje);
        }
        // else if (this.user.usuario == message.fromUsuario && message.tipo == 'I') {
        //   // Usuario LogIn
        //   this.user.status = 'online';
        // } else if (this.user.usuario == message.fromUsuario && message.tipo == 'O') {
        //   // Usuario LogOut
        //   this.user.status = 'incognito';
        // }
      }
      // this._ngZone.run(() => {
      //   this.chatMessage = new ChatMessage();
      //   let room = this.tabs.find(t => t.heading == message.room);
      //   if (room) {
      //       room.messageHistory.push(new ChatMessage(message.user, message.message, message.room));
      //   }
      // });
    });
  }

  ngOnInit() {
    // this.currentUser = JSON.parse(localStorage.getItem('currentUser'));
  }

  // ngOnInit() {
  //   this.chatService.chatMessage.subscribe((message) => {
  //     this.receiveMessage(message);
  //   });

  //   this.chatService.sessionClosed.subscribe(() => {
  //     chatboxManager.delBox(this.state.chatId);
  //   });

  //   this.chatService.statusChanged.subscribe((message) => {
  //     if (this.user.usuario == message.usuario) {
  //       if (message.status == 'ON') {
  //         this.user.status = 'online';
  //       } else {
  //         this.user.status = 'incognito';
  //       }
  //      }
  //   });
  //   // chatboxManager.setChatService(this.chatService);
  // }

  receiveMessage(mensaje: ChatMensaje) {
    // console.log('Recibido3:', mensaje);

    // console.log('received ', mensaje);
    const currentUser = JSON.parse(localStorage.getItem('currentUser'));
    if (this.user.usuario == mensaje.fromUsuario && currentUser.claveUsuario == mensaje.toUsuario) {
      this.openChat();
      // chatboxManager.received(this.state.chatId, { first_name: mensaje.fromUsuario }, mensaje.mensaje);

      const id = 'chatbox-user-' + this.user.idUsuario;
      chatboxManager.received(id, { first_name: this.user.first_name }, mensaje.mensaje);

    }
  }

  openChat() {
    const user = this.user;
    // const [firstname, lastname] = user.usuario.split(/ /);

    // const id = this.state.chatId;
    const currentUser = JSON.parse(localStorage.getItem('currentUser'));
    const id = 'chatbox-user-' + user.idUsuario;
    // console.log(id);
    if (user.status != 'ofline') {
      chatboxManager.addBox(id, {
        user_name: user.usuario,
        title: user.nombre,
        first_name: user.nombre,
        last_name: user.apellido,
        status: user.status || 'online',
        alertmsg: user.status == 'busy' ? user.username + ' está ocupado. No molestar!' : '',
        alertshow: user.status == 'busy'
        // you can add your own options too
      }, this.signalrService);
    }
  }

  openChatBox(e) {
    e.preventDefault();
    this.openChat();
  }
}



// WEBPACK FOOTER //
// C:/Users/stivens/Lab/sonever/repos/taller-web/src/app/shared/chat/aside-chat-user/aside-chat-user.component.ts